import React from 'react';
import { useLinesContext } from '../../../contexts/Lines';
import { useEditLineContext } from '../../../contexts/EditLine';
import makeStyles from '@material-ui/core/styles/makeStyles';
import moment from 'moment';
import IconButton from '@material-ui/core/IconButton';

const useStyles = makeStyles((theme: any) => ({
  arrow: {
    position: 'sticky',
    zIndex: 101,
    width: '25px',
    height: '25px',
    top: 59,
    gridRow: ({ moveForward }: any) => {
      return `1/${moveForward ? 14 : 1}`;
    },
    gridColumn: ({ moveForward }: any) => {
      return moveForward ? '14' : '1';
    },
  },
}));

export default function MoveTimelineButton({ moveForward }) {
  const classes = useStyles({ moveForward });
  const { timelineInfo, setTimelineInfo } = useLinesContext();
  const { leftArrowRef, rightArrowRef } = useEditLineContext();

  const subtractMonth = () => {
    const clonedMonths = timelineInfo.months.map((month) =>
      month.subtract(1, 'months'),
    );
    setTimelineInfo({
      start: timelineInfo.start.subtract(1, 'months'),
      end: timelineInfo.end.subtract(1, 'months').endOf('M'),
      totalMonths: timelineInfo.totalMonths,
      totalDays: moment().diff(
        moment().add(timelineInfo.totalMonths, 'M'),
        'days',
      ),
      months: clonedMonths,
    });
  };

  const addMonth = () => {
    const clonedMonths = timelineInfo.months.map((month) =>
      month.add(1, 'months'),
    );
    setTimelineInfo({
      start: timelineInfo.start.add(1, 'months'),
      end: timelineInfo.end.add(1, 'months').endOf('M'),
      totalMonths: clonedMonths.length,
      totalDays: moment().diff(moment().add(clonedMonths.length, 'M'), 'days'),
      months: clonedMonths,
    });
  };

  function onClick() {
    if (moveForward) {
      addMonth();
    } else {
      subtractMonth();
    }
  }

  const icon = moveForward ? 'icons/arrowRight.svg' : 'icons/arrowLeft.svg';
  const ref = moveForward ? rightArrowRef : leftArrowRef;
  return (
    <IconButton ref={ref} onClick={onClick} className={classes.arrow}>
      <img src={icon} alt="Move timeline button" />
    </IconButton>
  );
}
